<article class="notification {{classes}}" [ngClass]="INDRA_printStyle()" tabindex="0" aria-label="Notification">
	<div class="notification__ring"></div>
	<div class="notification__icon">
		<app-svg *ngIf=icon svg="{{INDRA_printIcon()}}" aria-hidden="true" [alt]="'Notification icon'"></app-svg>
	</div>
	<div class="notification__header">
			<div class="notification__text">
				<h5 *ngIf=title class="title-h5">
					<span skeletonLoader [translationKey]="titleKey">
						{{INDRA_printTitle()}}
					</span>
				</h5>
				<ng-content select="[message]"></ng-content>
			</div>
			<div class="notification__actions">
				<ng-content select="[actions]"></ng-content>
			</div>
			<button *ngIf=close class="notification__close" aria-label="Close notification" (click)="INDRA_close()">
				<app-svg svg="icons.svg#general--close" aria-hidden="true" [alt]="'Close icon'"></app-svg>
			</button>
	</div>
	<div class="notification__body">
		<ng-content select="[body]"></ng-content>
	</div>
</article>